import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type FilterPanelColumns = number | string;

let nextId = 0;

const CARD_CLASSES =
  'rounded-aav-sm border-[1px] border-solid border-aav-neutral-200 bg-aav-surface ' +
  'px-[1.25rem] py-[0.875rem]';

const HEADING_CLASSES = 'mt-0 mb-[1rem] text-aav-title-medium-strong text-aav-on-surface';

const FIELDS_CLASSES = 'grid items-end gap-[0.875rem]';

const SUBMIT_CLASSES = '[&>button]:uppercase';

const DEFAULT_COLUMNS = 3;

function fieldTracks(columns: FilterPanelColumns): string {
  if (typeof columns !== 'number') return columns;
  return `repeat(${Math.max(1, Math.trunc(columns))}, minmax(0, 1fr))`;
}

@Component({
  selector: 'aav-filter-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  template: `
    <section
      [class]="cardClasses"
      role="search"
      [attr.aria-labelledby]="heading ? headingId : null"
    >
      <h2 *ngIf="heading" [id]="headingId" [class]="headingClasses">{{ heading }}</h2>

      <div [class]="fieldsClasses" [style.grid-template-columns]="gridTemplateColumns">
        <ng-content></ng-content>

        <aav-button
          *ngIf="submitLabel"
          type="submit"
          variant="outlined-neutral"
          data-action="search"
          [class]="submitClasses"
          [trailingIcon]="submitIcon"
          [disabled]="submitDisabled"
          [loading]="submitLoading"
        >
          {{ submitLabel }}
        </aav-button>
      </div>
    </section>
  `,
})
export class FilterPanelComponent {
  @Input() heading = '';
  @Input() submitLabel = '';
  @Input() submitIcon = 'search';
  @Input() submitDisabled = false;
  @Input() submitLoading = false;
  @Input() columns: FilterPanelColumns = DEFAULT_COLUMNS;

  readonly headingId = `aav-filter-panel-${nextId++}`;
  readonly cardClasses = CARD_CLASSES;
  readonly headingClasses = HEADING_CLASSES;
  readonly fieldsClasses = FIELDS_CLASSES;
  readonly submitClasses = SUBMIT_CLASSES;

  get gridTemplateColumns(): string {
    const tracks = fieldTracks(this.columns);
    return this.submitLabel ? `${tracks} auto` : tracks;
  }
}
